<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <div>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md4>
                        <v-text-field v-model="filters.resCat" :label="labels.resCat" :error-messages="errors.collect('resCat')" data-vv-name="resCat" :data-vv-as="labels.resCat" v-validate="'name|max:3'"></v-text-field>
                      </v-flex>
                      <v-flex md4>
                        <v-text-field v-model="filters.resCatShortDesc" :label="labels.resCatShortDesc" :error-messages="errors.collect('resCatShortDesc')" data-vv-name="resCatShortDesc" :data-vv-as="labels.resCatShortDesc" v-validate="'name|max:6'"></v-text-field>
                      </v-flex>
                      <v-flex md4>
                        <v-text-field v-model="filters.resCatLongDesc" :label="labels.resCatLongDesc" :error-messages="errors.collect('resCatLongDesc')" data-vv-name="resCatLongDesc" :data-vv-as="labels.resCatLongDesc" v-validate="'name|max:20'"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md4>
                        <v-text-field v-model="filters.posNegEither" :label="labels.posNegEither" :error-messages="errors.collect('posNegEither')" data-vv-name="posNegEither" :data-vv-as="labels.posNegEither" v-validate="'name|max:1'"></v-text-field>
                      </v-flex>
                      <v-flex md4>
                        <v-text-field v-model="filters.paytRcvy" :label="labels.paytRcvy" :error-messages="errors.collect('paytRcvy')" data-vv-name="paytRcvy" :data-vv-as="labels.paytRcvy" v-validate="'name|max:1'"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNew()">
            New Reserve Category
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td>{{ row.item.resCat }}</td>
                <td>{{ row.item.resCatShortDesc }}</td>
                <td>{{ row.item.resCatLongDesc }}</td>
                <td>{{ row.item.posNegEither }}</td>
                <td>{{ row.item.paytRcvy }}</td>
                <td>{{ row.item.chkSi }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doReview(row.item.resCat)" query @query="doQuery(row.item.resCat)" remove @remove="doPromptRemove(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Reserve Category?
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Claims Reserve Category', value: 'resCat' },
        { text: 'Short Description', value: 'resCatShortDesc' },
        { text: 'Long Description', value: 'resCatLongDesc' },
        { text: 'PNE', value: 'posNegEither' },
        { text: 'Payment or Recovery', value: 'paytRcvy' },
        { text: 'Check SI', value: 'chkSi' },
        TableConst.tableActionHeader
      ],
      labels: {
        resCat: 'Claims Reserve Category',
        resCatShortDesc: 'Short Description',
        resCatLongDesc: 'Long Description',
        posNegEither: 'PNE',
        paytRcvy: 'Payment or Recovery',
        chkSi: 'Check SI'
      },
      filters: {
        resCat: undefined,
        resCatShortDesc: undefined,
        resCatLongDesc: undefined,
        posNegEither: undefined,
        paytRcvy: undefined
      },
      sideFunction: [
        {
          text: 'Permit Business Class',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'pmtClmResCatPerBusClsList' }
        }
      ],
      totalItems: 0,
      selectedResCat: undefined,
      deleteResCat: undefined,
      loading: false,
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getClmResCatList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                if (datamap.chkSi === false) {
                  datamap.chkSi = 'No'
                } else if (datamap.chkSi === true) {
                  datamap.chkSi = 'Yes'
                } else {
                  datamap.chkSi = '-'
                }
                const convertList = {
                  resCat: datamap.resCat,
                  resCatShortDesc: datamap.resCatShortDesc,
                  resCatLongDesc: datamap.resCatLongDesc,
                  posNegEither: datamap.posNegEither,
                  paytRcvy: datamap.paytRcvy,
                  chkSi: datamap.chkSi
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.resCat = null
      this.filters.resCatShortDesc = null
      this.filters.resCatLongDesc = null
      this.filters.posNegEither = null
      this.filters.paytRcvy = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doReview(resCat) {
      this.$router.push({ name: 'clmResCatReview', params: { resCat: resCat, resCatMode: 'Review' } })
    },
    doQuery(resCat) {
      this.$router.push({ name: 'clmResCatReview', params: { resCat: resCat, resCatMode: 'Query' } })
    },
    doNew() {
      this.$router.push({ name: 'clmResCatReview', params: { resCat: 'new', resCatMode: 'New' } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedResCat = data
        this.deleteResCat = data.resCat
      }
    },
    async doRemove() {
      const apiURI = this.menu.deleteClmResCat
      if (apiURI) {
        const chkSi = this.selectedResCat.chkSi
        if (chkSi === 'No') {
          this.selectedResCat.chkSi = false
        } else if (chkSi === 'Yes') {
          this.selectedResCat.chkSi = true
        } else if (chkSi === '-') {
          this.selectedResCat.chkSi = null
        }
        const expand = this.selectedResCat
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.clsResCatParam.menu
    }
  },
  mounted() {
    this.doInit(true)
  },
  components: {
    SideFunctionMenu
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
